import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect'
import "@lottiefiles/lottie-player";
import {initAnimations} from './animations.js';
import {initBackgrounds} from "./backgrounds";
import {initGrid} from "./projectGrid";
 
Alpine.plugin(intersect)
 
Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();

initBackgrounds();
initAnimations();
initGrid();
